import React from 'react';

const RateListTable = ({...props}) => {
    const tableHead = props.tableHead;
    const tableData = props.tableData;

    return (
        <>{tableData.length > 0 &&
        <div className='flex mb-4 overflow-auto leading-5'>
            <table className='w-full border-collapse border border-gray-200 bg-white' cellPadding={3}>
                <thead>
                <tr>
                    {tableHead.map((heading, idx) => {
                    return (
                        <th key={`head-${heading.id}-${idx}`} width={heading.width} className='border border-gray-200 bg-slate-100 font-semibold whitespace-nowrap text-nowrap'>{heading.title}</th>
                        );
                    })} 
                </tr>
                </thead>
                <tbody>
                {props.title === 'Rate List (Plots)' ? 
                    <>{tableData.map((data, idx) => {
                    return (
                        <tr key={`row-${data.id}-${idx}`}>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.id}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.block}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.plot}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.minarea}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.maxarea}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.rate}</div></td>
                        </tr>
                        );
                    })}</> :
                    <>{tableData.map((data) => {
                    return (
                        <tr key={data.id}>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.id}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.block}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.size}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.plotarea}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.coveredarea}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.fasing}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.rooms}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.washroom}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.mumty}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap'>{data.semirate}</div></td>
                            <td className='border border-gray-200'><div className='text-center text-nowrap' dangerouslySetInnerHTML={{ __html: data.rate }}></div></td>
                        </tr>
                        );
                    })}</>
                }                    
                </tbody>
            </table>
        </div>
        }</>
    );
}

export default RateListTable;